import { combineReducers } from 'redux'
import fetchReducer from './fetchReducer'
import resourceBundleReducer from './resourceBundleReducer'
import formReducer from './formReducer'
import nextSubmitReducer from './nextSubmitReducer'
import pageSubmitReducer from './pageSubmitReducer'
import getTemplatePropertiesReducer from './getTemplatePropertiesReducer'
import paginationReducer from './paginationReducer'
import rowsPerPageOptionReducer from './rowsPerPageOptionReducer'
import loginFormReducer from './loginFormReducer'
import logOutReducer from './logOutReducer'
// import solrPaginationReducer from './solrPaginationReducer'
// import solrFacetReducer from './solrFacetReducer'
import getUrlMappingsReducer from './getUrlMappingsReducer'
import getLoaderStatusReducer from './getLoaderStatusReducer'
import getLoginStatusReducer from './getLoginStatusReducer'
import getCartUpdatedStatusReducer from './getCartUpdatedStatusReducer'
import getProfileDetailsReducer from './getProfileDetailsReducer'
import updateAddToCartReducer from './updateAddToCartReducer'
import getShoppingListDetailsReducer from './getShoppingListDetailsReducer'
import updateShoppingListDetailsReducer from './updateShoppingListDetailsReducer'



export default combineReducers({
    fetch: fetchReducer,
    resourceBundle: resourceBundleReducer,
    form: formReducer,
    nextSubmit: nextSubmitReducer,
    pageSubmit: pageSubmitReducer,
    getTemplateProperties: getTemplatePropertiesReducer,
    tablePagination: paginationReducer,
    tablerowsPerPage: rowsPerPageOptionReducer,
    loginForm: loginFormReducer,
    logOut: logOutReducer,
    getUrlMappings: getUrlMappingsReducer,
    getLoaderStatus: getLoaderStatusReducer,
    getLoginStatus: getLoginStatusReducer,
    getCartUpdatedStatus: getCartUpdatedStatusReducer,
    getProfileDetails: getProfileDetailsReducer,
    updateAddToCart: updateAddToCartReducer,
    getShoppingListDetails:getShoppingListDetailsReducer,
    updateShoppingListDetailsReducer:updateShoppingListDetailsReducer
})
